import Container from "../components/Container";
import missionPhoto from "../assets/Girl_Bear.jpg";

export default function Mission() {
  return (
    <section
      id="mission"
      className="bg-white min-h-screen flex items-center py-24 md:py-0"
    >
      <Container>
        <div className="flex flex-col md:flex-row items-center md:items-stretch gap-16">
          
          {/* Text Column */}
          <div className="md:w-1/2 flex flex-col justify-center text-center md:text-left">
            <h2 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold mb-10">
              Our Mission
            </h2>

            <p className="text-xl sm:text-2xl md:text-3xl text-gray-700 leading-relaxed">
              Teddy’s Tallow exists to bring back ingredients humans relied on for
              generations — thoughtfully sourced, carefully prepared, and used
              with intention. We believe tallow deserves a place in both the
              kitchen and personal care, without compromise or shortcuts.
            </p>
          </div>

          {/* Image Column */}
          <div className="md:w-1/2 flex justify-center md:justify-end">
            <img
              src={missionPhoto}
              alt="Happy customer holding Teddy's Tallow product"
              className="rounded-2xl shadow-lg w-full max-w-lg md:max-w-xl object-cover"
            />
          </div>

        </div>
      </Container>
    </section>
  );
}
